// © 2025 nSide, Inc. All Rights Reserved.
// This software and its source code are the confidential and proprietary
// information of nSide, Inc. (“Confidential Information”). You may not
// use, reproduce, disclose, distribute, modify, or create derivative works
// of this code except in accordance with a written license agreement or
// other written authorization from nSide, Inc.

// Unauthorized use is strictly prohibited and may result in civil and
// criminal penalties.



import { Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ErrorComponent } from './components/error/error.component';

export const routes: Routes = [
  { path: '', redirectTo: '/0', pathMatch: 'full' },
  { path: 'error', component: ErrorComponent },
  { path: ':featureId', component: DashboardComponent }
];
